<form class="timeGrid" [formGroup]="timeForm">
  <ls-single-select
    [formControl]="timeForm.controls.hour"
    [items]="hours"
    [placeholder]=""
    [activeItem]="timeForm.controls.hour.value"
  ></ls-single-select>

  <ls-single-select
    [formControl]="timeForm.controls.minute"
    [items]="minutes"
    [placeholder]=""
    [activeItem]="timeForm.controls.minute.value"
  ></ls-single-select>

  <ls-single-select
    *ngIf="timeForm.controls.meridian"
    [formControl]="timeForm.controls.meridian"
    [items]="amPm"
    [disabled]="disabled"
    [activeItem]="timeForm.controls.meridian.value"
  ></ls-single-select>
</form>
